module.exports = __webpack_public_path__ + "img/reaction2.3a71388d.png";